import { render, staticRenderFns } from "./ShowPowerGuardSurveyResults.vue?vue&type=template&id=0155dcc0&"
import script from "./ShowPowerGuardSurveyResults.vue?vue&type=script&lang=js&"
export * from "./ShowPowerGuardSurveyResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports